import { Grid } from "@mui/material";

import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { isCallPermissionRequestTemplate, isCatalogTemplate, isInteractiveTypeMessageList, needToShowHeader, needToShowInteractiveButtons, needToShowTypeOfVariable, shouldShowTemplateFooter } from "../../../channels/global/whatsapp/templates/utils";

import WhatsAppTemplateFormHeader from "./WhatsAppTemplateFormHeader";
import WhatsAppTemplateFormBody from "./WhatsAppTemplateFormBody";
import WhatsAppTemplateFormButtons from "./WhatsAppTemplateFormButtons";
import WhatsAppTemplateFormFooter from "./WhatsAppTemplateFormFooter";
import WhatsAppTemplateFormTypeOfVariable from "./WhatsAppTemplateFormTypeOfVariable";
import WhatsAppTemplateFormBodyDescription from "./WhatsAppTemplateFormBodyDescription";
import { useShallow } from "zustand/react/shallow";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { isInteractiveTemplate, isTemplateCreated } from "../../constant";
import WhatsAppTemplateFormButtonTextforListType from "./WhatsAppTemplateFormButtonTextforListType";

const WhatsAppTemplateForm = (props: any) => {

    const { handleChangeText, handleAddBodyVariableManually, removeVariableData, handleAddField, handleChange, 
        handleRemoveField, headerTextareaRef, uploadFileHandler, removeFileHandler, textareaRef, onChangeOfHeader, anchorEl, menuPosition, handleClick, 
        checkDisableAddButton, calculateMenuPosition, getMenuDisableFlag, handleClose, handleAddActionsButton, renderCustomButtonField, 
        getInput, flagShowVariableTooltipForVisitWebsite, handleDeleteActionBtn, setOnChangeOfPayloadObject, checkForAddDynamicVar, 
        getWebsiteUrlValue, handleChangeCallField, handleChangeFieldVal, isFlowButton, setPayloadOnChangeOfGetInput, handleSampleTextChange, isFileUploaded, inValidId, 
        checkTypeOfVariableValidation, handleFormatting, handleExpirationChange, handleSecurityRecommendationChange, inDrawer, registerTextarea, handleAddExpiryTimeChange
    } = props;

    const { createTemplatePayload, interactiveTypeList, whatsappTemplateTypes, templateLibraryCategoryList, existingTemplateData } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
        interactiveTypeList: state.interactiveTypeList,
        whatsappTemplateTypes: state.whatsappTemplateTypes,
        templateLibraryCategoryList: state.templateLibraryCategoryList,
        existingTemplateData: state.existingTemplateData,
    })));

    // Constants
    const shouldShowHeader = needToShowHeader(createTemplatePayload, interactiveTypeList, whatsappTemplateTypes, templateLibraryCategoryList)
        && !(isTemplateCreated(createTemplatePayload) && createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_id == null);

    const shouldShowFooter = shouldShowTemplateFooter(createTemplatePayload, interactiveTypeList, existingTemplateData);

    const shouldShowButtonTextforListType = isInteractiveTemplate(createTemplatePayload) && isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList);

    const showShowButtons = needToShowInteractiveButtons(createTemplatePayload, interactiveTypeList, whatsappTemplateTypes);

    const shouldShowTypeOfVariable = needToShowTypeOfVariable(createTemplatePayload, templateLibraryCategoryList);

    const isTemplateTypeCatalog = isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id);
    const isTemplateTypeCallPermissionRequest = isCallPermissionRequestTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id);

    return (
        <Grid container 
            className={`
                ${styles.whatsappTemplateForm} ${inDrawer ? styles.whatsappTemplateForm_inDrawer : ""} 
                ${globalStyles.fullwidth}
            `}
        >

            {/* Template Configuration Title */}
            <Grid item xs={12} className={styles.whatsappTemplateForm__titleDescriptionContainer}>
                <div className={styles.whatsappTemplateForm__title}>
                    {`${isInteractiveTemplate(createTemplatePayload) 
                        ? "Interactive" 
                        : isTemplateTypeCatalog 
                            ? "Catalog" 
                            : isTemplateTypeCallPermissionRequest
                                ? "Call Permission Request"
                                : "Template"
                        } 
                    Configuration`}
                </div>
            </Grid>


            {/* Basic Template Form */}
            <Grid item xs={12} className={styles.whatsappTemplateForm__formContainer}>

                {shouldShowHeader &&
                    <WhatsAppTemplateFormHeader 
                        handleChangeText={handleChangeText}
                        handleAddBodyVariableManually={handleAddBodyVariableManually}
                        removeVariableData={removeVariableData}
                        handleAddField={handleAddField}
                        handleChange={handleChange}
                        handleRemoveField={handleRemoveField}
                        headerTextareaRef={headerTextareaRef}
                        uploadFileHandler={uploadFileHandler}
                        removeFileHandler={removeFileHandler}
                        onChangeOfHeader={onChangeOfHeader}
                        isFileUploaded={isFileUploaded}
                        checkTypeOfVariableValidation={checkTypeOfVariableValidation}
                        registerTextarea={registerTextarea}
                    />
                }
                
                <WhatsAppTemplateFormBody 
                    handleChangeText={handleChangeText}
                    handleAddBodyVariableManually={handleAddBodyVariableManually}
                    removeVariableData={removeVariableData}
                    handleAddField={handleAddField}
                    handleChange={handleChange}
                    handleRemoveField={handleRemoveField}
                    headerTextareaRef={headerTextareaRef}
                    textareaRef={textareaRef}
                    checkTypeOfVariableValidation={checkTypeOfVariableValidation}
                    handleFormatting={handleFormatting}
                    handleSecurityRecommendationChange={handleSecurityRecommendationChange}
                    registerTextarea={registerTextarea}
                />
                
                {shouldShowFooter &&
                    <WhatsAppTemplateFormFooter 
                        handleChangeText={handleChangeText} 
                        handleExpirationChange={handleExpirationChange}
                        handleAddExpiryTimeChange={handleAddExpiryTimeChange}
                    />
                }

                {shouldShowButtonTextforListType &&
                    <WhatsAppTemplateFormButtonTextforListType />
                }
                
                {showShowButtons && 
                    <WhatsAppTemplateFormButtons 
                        editFromPreview={false} 
                        anchorEl={anchorEl}
                        menuPosition={menuPosition}
                        handleClick={handleClick} 
                        checkDisableAddButton={checkDisableAddButton} 
                        calculateMenuPosition={calculateMenuPosition}
                        getMenuDisableFlag={getMenuDisableFlag}
                        handleClose={handleClose}
                        handleAddActionsButton={handleAddActionsButton}
                        renderCustomButtonField={renderCustomButtonField}
                        getInput={getInput}
                        flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                        handleDeleteActionBtn={handleDeleteActionBtn}
                        setOnChangeOfPayloadObject={setOnChangeOfPayloadObject}
                        checkForAddDynamicVar={checkForAddDynamicVar}
                        getWebsiteUrlValue={getWebsiteUrlValue}
                        handleChangeCallField={handleChangeCallField}
                        handleChangeFieldVal={handleChangeFieldVal}
                        isFlowButton={isFlowButton}
                        setPayloadOnChangeOfGetInput={setPayloadOnChangeOfGetInput}
                        handleSampleTextChange={handleSampleTextChange}
                        inValidId={inValidId}
                    />
                }

                {shouldShowTypeOfVariable &&
                    <WhatsAppTemplateFormTypeOfVariable />
                }

                {/* <WhatsAppTemplateFormBodyDescription /> */}
            
            </Grid>

        </Grid>
    )

}

export default WhatsAppTemplateForm;

